/* global axios */

export default {
  getKeys(accountId) {
    return axios.get(`/api/v1/accounts/${accountId}/tracking_api_keys`);
  },

  createKey(accountId, data) {
    return axios.post(`/api/v1/accounts/${accountId}/tracking_api_keys`, data);
  },

  deleteKey(accountId, keyId) {
    return axios.delete(`/api/v1/accounts/${accountId}/tracking_api_keys/${keyId}`);
  },
};
